

const dateToText = (inputDate) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return inputDate.toLocaleDateString(undefined, options);
}

var today = new Date()
// today.setDate(1)
// console.log(today)
const min_dob = new Date("1953-12-06");
const max_dob = new Date();
max_dob.setFullYear(today.getFullYear() - 50);
const max_dob_text = dateToText(max_dob)
const min_dob_text = dateToText(min_dob)

function isValidDateString(some_string) {
    const date = new Date(some_string);
    return date instanceof Date && !isNaN(date);
}

function validateDOB(memberInfo) {
    const dob = memberInfo.dateOfBirth;

    if (!dob) {
        return 'Please select a date';
    }

    if (!isValidDateString(dob)) {
        return 'Please enter a valid date';
    }

    const dob_date = new Date(dob);

    if (dob_date < min_dob) {
        return "Your date of birth cannot be before 6 December 1953 because this illustrator cannot account for some of the special circumstances that would be applicable.";
    }

    if (dob_date > max_dob) {
        return  "You cannot use this illustrator if you are less than 50 years old."
    }

    return ''; // No errors
}

function validateDJS(memberInfo, dobError, legacySchemeError) {
    if(dobError !== '') {
        return '' //We cannot properly validate DJS if we don't have a DOB, and in any case the member will not be able to proceed until they correct the DOB error
    }

    if(legacySchemeError !== '') {
        return '' //We cannot properly validate DJS if we don't have a DOB, and in any case the member will not be able to proceed until they correct the DOB error
    }

    let max_djs, min_djs;
    
    if (dobError === '') {
        min_djs = new Date(memberInfo.dateOfBirth);
        min_djs.setFullYear(min_djs.getFullYear() + 16);
    }

    const isPremium = memberInfo.legacyScheme === 'premium'
    if (isPremium) {
        //min_djs = new Date("2002-10-01");
        max_djs = new Date("2007-07-30"); 
    } else {
        max_djs = new Date("2002-09-30");
    } 

    const djs = memberInfo.dateJoinedScheme;

    if (!djs) {
        return 'Please enter a date';
    }

    if (!isValidDateString(djs)) {
        return 'Please enter a valid date';
    }

    const djs_date = new Date(djs);

    if (isNaN(djs_date.getTime())) {
        return 'Please enter a valid date';
    }

    if (djs_date < min_djs) {
        //if(isPremium) {
        //    return 'As a premium scheme member, your joining date must be after ' + dateToText(min_djs) ;
        //} else {
            return 'Your joining date cannot be before your 16th birthday'
        //}
        
    }

    if (djs_date > max_djs) {
        return 'As a member of the ' + memberInfo.legacyScheme.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) + ' scheme, your joining date must be on or before ' + dateToText(max_djs);
    }

    return ''; // No errors
}

function validateParAge(memberInfo, dobError) {

    if(dobError !== '') {
        return '' //We cannot properly validate DJS if we don't have a DOB, and in any case the member will not be able to proceed until they correct the DOB error
    }
    
    const dob_date = new Date(memberInfo.dateOfBirth)
    
    var min_par_age = dob_date;
    min_par_age.setFullYear(min_par_age.getFullYear() + 55);
    min_par_age.setDate(1)
    min_par_age.setHours(0,0,0,0);
    today.setHours(0,0,0,0);

    // Move to next month
    var nextMonth = today.getMonth() + 1; // get next month (note: months are 0-indexed)
    var nextMonthYear = today.getFullYear();
    // If current month is December, increment the year
    if (nextMonth > 11) {
        nextMonth = 0;
        nextMonthYear += 1;
    }

    var today_first = new Date(nextMonthYear, nextMonth, 1);
    today_first.setHours(0,0,0,0);
    
    min_par_age = min_par_age > today_first ? min_par_age : today_first;

    let max_ret_date = new Date();
    max_ret_date.setFullYear(max_ret_date.getFullYear() + 1);

    let max_par_age;
    
    max_par_age = new Date(memberInfo.dateOfBirth);
    max_par_age.setFullYear(max_par_age.getFullYear() + 75);
    
    const par = memberInfo.dateOfPartRet

    if(par === '') {
        return 'Please select a date'
    }

    if(!isValidDateString(par)) {
        return 'Please select a valid date'
    }
    
    const parDate = new Date(par)  

    if(parDate < min_par_age) {
        return 'Your partial retirement date must be on or after your 55th birthday, and must be after today'
    }

    if(parDate > max_par_age) {
        return 'Your partial retirement date cannot be after your 75th birthday'
    }

    return ''

}

function validateSalaryCurrent(pay) {
    
    if(pay === "") {
        return 'Please enter your current full-time equivalent pensionable earnings'
    }

    if(Number(pay) < 1) {
        return 'Your current full-time equivalent pensionable earnings must be above £1'
    }

    return ''
}

function validateSalaryApril2015(memberInfo) {
    const pay = memberInfo.salaryApril2015

    if(pay === '') {
        return ''
    }

    if(Number(pay) > 0 && Number(pay) <=1) {
        return 'Your April 2015 full-time equivalent pensionable earnings must be above £1. As noted above, if this is unknown, please enter £0.'
    }

    return ''
}

function validatePostParPT(memberInfo) {
    const pt = memberInfo.partTimeServicePostPartRet

    if(pt === ''){
        return 'Please input a value'
    }

    if(pt < 1) {
        return 'This value must be 1% or more'
    }
    
    return ''
}

function calculatePartTimePercentage(periods, date_of_pr) {
    if(periods === undefined) {
        console.log('No PT')
        return 1
    }
    const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
    const ONE_YEAR_IN_DAYS = 365; // Assuming a non-leap year for simplicity
    const endDate = new Date(date_of_pr);
    const startDate = new Date(endDate.getTime() - ONE_YEAR_IN_DAYS * MILLISECONDS_IN_DAY);
  
    let totalDays = 0;
    let weightedPercentageSum = 0;
  
    periods.forEach(({ FROM, TO, PROPORTION }) => {
      const fromDate = new Date(FROM);
      const toDate = new Date(TO);
  
      // Adjust the period to fit within the 12-month window before date_of_pr
      const periodStart = fromDate < startDate ? startDate : fromDate;
      const periodEnd = toDate > endDate ? endDate : toDate;
  
      // Only consider the period if it overlaps with the 12-month window
      if (periodEnd >= startDate && periodStart <= endDate) {
        const overlapDays = Math.max(0, (periodEnd - periodStart) / MILLISECONDS_IN_DAY);
        totalDays += overlapDays;
        weightedPercentageSum += overlapDays * (parseFloat(PROPORTION) / 100);
      }
    });
  
    // Calculate the uncovered days, which default to 100% FTE
    const uncoveredDays = ONE_YEAR_IN_DAYS - totalDays;
    weightedPercentageSum += uncoveredDays; // Add full FTE for uncovered days
  
    // Final percentage calculation
    const overallPercentage = (weightedPercentageSum / ONE_YEAR_IN_DAYS);
  
    return overallPercentage.toFixed(2);
  }
  
  // Example usage:
  /*
  const periods = [
    { "FROM": "2001-01-01", "TO": "2002-01-01", "PROPORTION": "50" },
    { "FROM": "2003-01-01", "TO": "2004-01-01", "PROPORTION": "60" },
    { "FROM": "2009-01-01", "TO": "2010-05-12", "PROPORTION": "22" }
  ];
  
  const date_of_pr = "2010-05-12";
  const result = calculatePartTimePercentage(periods, date_of_pr);
  console.log(result); 
  */

function validateSalaryPostPart(memberInfo) {
    var pay = memberInfo.salaryPostPartRet;
    var partservice = memberInfo.partTimeServicePostPartRet;
 // Loaded variables for the post partial retirement salary and the post partial retirement service
    if(pay === "") {
        return 'Please enter your post-partial retirement salary percentage' //Changed from salary to salary percentage
    }

    
    if(pay < 1) {
        return 'This value must be 1% or more' //Changed this from £1 to 1%
    }
 //  SalaryPostPartTime= Post_partial_retirement% * Part_time_service%
    const SalaryPostPartTime = (pay / 100) * (partservice / 100) * 100;

    if (SalaryPostPartTime > 80) {
        return 'Your post-partial retirement pensionable earnings are greater than 80% of your pre-partial retirement pensionable earnings. Please reduce either your post-partial retirement salary percentage or your post-partial retirement part-time percentage.'
    }
 
    return ''
}

//The added validation has to check post-partial retirement pensionable earnings is less than 80% of pre-partial retirement pensionable earnings.
/*
Example usage:

Post_partial_retirement% = 80%
Part_time_service% = 60%
Salary_post_part_time_service = Post_partial_retirement% * Part_time_service%
Salary_post_part_time_service = 80% * 60%
Salary_post_part_time_service = 43.2% < 80%, this passes the validation.

Post_partial_retirement% = 90%
Part_time_service% = 90%
Salary_post_part_time_service = Post_partial_retirement% * Part_time_service%
Salary_post_part_time_service = 92% * 92%
Salary_post_part_time_service = 84.6% > 80%, this fails the validation.
*/


export const inputValidations = (memberInfo) => {

    const today = new Date();
    

    // 1. legacyScheme - No explicit validation mentioned, always true for now
    const legacySchemeError = memberInfo.legacyScheme === '' ? 'Please select an option' : '';

    // 2. dateOfBirth (dob)
    const dobError = validateDOB(memberInfo)
    
    // 3. dateJoinedScheme (djs)
    const djsError = validateDJS(memberInfo, dobError, legacySchemeError)

    // 4. dateOfPartRet (parAge)
    const parAgeError = validateParAge(memberInfo, dobError)

    // 5. salaryCurrent (CurrentPen)
    const salaryCurrentError = validateSalaryCurrent(memberInfo.salaryCurrent)

    // 6. salaryApril2015 - No specific validation mentioned, always true for now
    const salaryApril2015Error = validateSalaryApril2015(memberInfo); 

    // 7. partTimeServicePostPartRet (postReshapingPT)
    const postReshapingPTValid = validatePostParPT(memberInfo)
        

    // 8. inReceipt - No specific validation mentioned, always true for now
    const inReceiptError = memberInfo.inReceipt === 'no' ? '' : (
        memberInfo.inReceipt === '' ? 'Please select an option' : 'You cannot use this illustrator if you are already in receipt of some or all of your pension'
    )

    // 9. hasLeft - No specific validation mentioned, always true for now
    const hasLeftError = memberInfo.hasLeft === 'yes' ? '' : (
        memberInfo.hasLeft === '' ? 'Please select an option' : 'You cannot use this illustrator if you are no longer an active member of the Northern Ireland Civil Service Pension Scheme'
    )

    // 10. salaryPostPartRet - No specific validation mentioned, always true for now
    const salaryPostPartRetValid = validateSalaryPostPart(memberInfo)

    // 11. isMcCloudEligible 
    // Note: Part-time service validations are skipped as requested
    const isMcCloudEligibleError = memberInfo.isMcCloudEligible === 'yes' ? '' : (
        memberInfo.isMcCloudEligible === '' ? 'Please select an option' : 
        (<>You cannot use this illustrator. You should use the Partial Retirement calculator at <a href="https://www.finance-ni.gov.uk/publications/partial-retirement-calculator" style={{color: "white"}} target="_blank">
        https://www.finance-ni.gov.uk/publications/partial-retirement-calculator</a>.</>)
    )

    return {
        'legacyScheme': legacySchemeError,
        'dateOfBirth': dobError,
        'dateJoinedScheme': djsError,
        'dateOfPartRet': parAgeError,
        'salaryCurrent': salaryCurrentError,
        'salaryApril2015': salaryApril2015Error,
        'partTimeServicePostPartRet': postReshapingPTValid,
        'inReceipt' : inReceiptError,
        'hasLeft' : hasLeftError,
        'salaryPostPartRet' : salaryPostPartRetValid,
        'isMcCloudEligible' : isMcCloudEligibleError
    };
}

function msgDJS(memberInfo) {

    let max_djs, min_djs;
    
    if (memberInfo.dateOfBirth !== '') {
        min_djs = new Date(memberInfo.dateOfBirth);
        min_djs.setFullYear(min_djs.getFullYear() + 16);
    }

    const isPremium = memberInfo.legacyScheme === 'premium'
    if (isPremium) {
        min_djs = new Date("2002-10-01");
        max_djs = new Date("2007-07-30"); 
    } else {
        max_djs = new Date("2002-09-30");
    } 

    const djs = memberInfo.dateJoinedScheme;

    if (!djs) {
        return '';
    }

    if (!isValidDateString(djs)) {
        return '';
    }

    const djs_date = new Date(djs);
    //console.log(djs.split('-')[0])

    if (djs.split('-')[0] > 1900 && djs_date < min_djs) {
        if(isPremium) {
            return 'If you are a Premium member with a date of joining the scheme before October 2002, ' +
            'we will assume that you opted to convert your pre-October 2002 service into Premium service. ' + 
            'Your pre-October 2002 service will be multiplied by 0.92 when calculating final salary benefits in ' + 
            'line with regulations. In some cases, the factor used to convert your pre-October 2002 service into ' +
            'the Premium scheme may differ slightly from 0.92 but this has not been allowed for.' ;
        } else {
            return ''
        }
        
    }

    return ''; // No errors
}

function msgSalaryCurrent(pay) {
    if(Number(pay) > 200000) {
        return 'We would expect that your current full-time equivalent pensionable earnings would not exceed £200,000. Please ensure you are content with the value you have entered before proceeding.'
    }

    return ''
}

function msgSalaryApril2015(pay) {
    if(Number(pay) > 200000) {
        return 'We would expect that your April 2015 full-time equivalent pensionable earnings would not exceed £200,000. Please ensure you are content with the value you have entered before proceeding.'
    }

    return ''
}

function msgSalaryPostPartRet(memberInfo) {
    const pay = memberInfo.salaryPostPartRet
    if(Number(pay) > 200000) {
        return 'We would expect that your post-partial retirement full-time equivalent pensionable earnings would not exceed £200,000. Please ensure you are content with the value you have entered before proceeding.'
    }
    return ''
}

function msgPartTimeServicePostPartRet(pt) {
    if(pt > 100) {
        return 'This value cannot be above 100%. If a value above 100% is entered, this will default to 100%.'
    }

    return ''
}

export const inputValidationsMsgs = (memberInfo) => {

    const today = new Date();
    

    // 1. legacyScheme - No explicit validation mentioned, always true for now
    // 2. dateOfBirth (dob)
    // 3. dateJoinedScheme (djs)
    const djsMsg = msgDJS(memberInfo)
    // 4. dateOfPartRet (parAge))
    // 5. salaryCurrent (CurrentPen)
    const salaryCurrentMsg = msgSalaryCurrent(memberInfo.salaryCurrent)
    // 6. salaryApril2015 - No specific validation mentioned, always true for now
    const salaryApril2015Msg = msgSalaryApril2015(memberInfo.salaryApril2015)
    // 7. partTimeServicePostPartRet (postReshapingPT)
    const partTimeServicePostPartRetMsg = msgPartTimeServicePostPartRet(memberInfo.partTimeServicePostPartRet)
    // 8. inReceipt - No specific validation mentioned, always true for now
    // 9. hasLeft - No specific validation mentioned, always true for now
    // 10. salaryPostPartRet - No specific validation mentioned, always true for now
    const salaryPostPartRetMsg = msgSalaryPostPartRet(memberInfo)
    // Note: Part-time service validations are skipped as requested

    return {
        'legacyScheme': '',
        'dateOfBirth': '',
        'dateJoinedScheme': djsMsg,
        'dateOfPartRet': '',
        'salaryCurrent': salaryCurrentMsg,
        'salaryApril2015': salaryApril2015Msg,
        'partTimeServicePostPartRet': partTimeServicePostPartRetMsg,
        'inReceipt' : '',
        'hasLeft' : '',
        'isMcCloudEligible' : '',
        'salaryPostPartRet' : salaryPostPartRetMsg
    };
}